import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Check from '@material-ui/icons/Check'
import { withStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'

const size = 32

const styles = theme => ({
  root: {
    height: size,
    width: size,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    borderRadius: size / 2,
    cursor: 'pointer',
    transition: 'all .3s ease',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  icon: {
    height: size / 2,
    width: size / 2,
    fill: theme.palette.white,
  },
})

const AcceptButton = ({
  classes, className, iconClassName, onClick 
}) => (
  <IconButton
    className={classNames(classes.root, className)}
    onClick={onClick}
    aria-label="Close">
    <Check className={classNames(classes.icon, iconClassName)} />
  </IconButton>
)

AcceptButton.defaultProps = {
  size: 32,
}

AcceptButton.propTypes = {
  size: PropTypes.number,
  onClick: PropTypes.func,
  classes: PropTypes.object,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
}

export default withStyles(styles)(AcceptButton)



// WEBPACK FOOTER //
// ./src/components/atoms/buttons/AcceptButton.js